import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService, MCardsTokenAuthenticationAction, UserAuthenticationService} from '../../../services/auth';

@Component({
  selector: 'app-mcards-login',
  template: '',
})
export class MCardsLoginComponent {

  constructor(private authService: AuthService, userService: UserAuthenticationService, private router: Router,
              activatedRoute: ActivatedRoute) {
    const token = activatedRoute.snapshot.queryParams['token'];
    const application = activatedRoute.snapshot.data['application'];
    if (token) {
      this.authService.login(new MCardsTokenAuthenticationAction(userService, {token, application}))
        .subscribe({
          next: () => {
            const _ = this.router.navigate([''])
          },
          error: (e) => {
            //TODO error handling
            console.error(e)
          },
        });
    } else {
      //TODO navigate to error page.
    }
  }

}
